import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import newRequest from "../../utils/newRequest";
import { CircularProgress } from "@mui/material";
import imageLiveUrl from "../../utils/urlConverter/imageLiveUrl";
import { useNavigate } from "react-router-dom";

const Slidersection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const slidesRef = useRef([]);

  const navigate = useNavigate();

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  const { t, i18n } = useTranslation();

  const {
    isLoading,
    error,
    data: slidersData,
  } = useQuery("fetchAllSliders", fetchFeaturesData);

  async function fetchFeaturesData() {
    const response = await newRequest.get("/getAllslider");
    return response?.data.filter((item) => item.status === 1) || [];
  }

  const { data: FaqsDataSliders } = useQuery(
    "fetchAllFaqSliders",
    fetchFeaturesrSlidersData
  );

  async function fetchFeaturesrSlidersData() {
    const response = await newRequest.get("/getAllheadings");
    return response?.data.filter((item) => item.status === 1) || [];
  }

  const thirdItem = FaqsDataSliders?.[0];

  useEffect(() => {
    const updateSlideHeight = () => {
      const heights = slidesRef.current.map((ref) => ref?.offsetHeight || 0);
      const maxHeight = Math.max(...heights);
      slidesRef.current.forEach((ref) => {
        if (ref) ref.style.height = `${maxHeight}px`;
      });
    };

    updateSlideHeight();
    window.addEventListener("resize", updateSlideHeight);

    return () => window.removeEventListener("resize", updateSlideHeight);
  }, [slidersData]);

  return (
    <div className="w-full py-10 mt-14 px-10 bg-[#f7f9fd]">
      <h2 className="text-4xl text-center leading-tight font-bold text-[#1d2331] my-10 font-lato">
        {i18n.language === "ar"
          ? thirdItem?.title_ar || ""
          : thirdItem?.title || ""}
      </h2>
      <Swiper
        slidesPerView={3}
        pagination={{ clickable: true }}
        onSlideChange={handleSlideChange}
        navigation={{
          nextEl: "#swiper-button-next",
          prevEl: "#swiper-button-prev",
        }}
        modules={[Pagination, Navigation]}
        className="mySwiper"
        breakpoints={{
          320: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {isLoading ? (
          <div className="flex justify-center items-center h-[420px]">
            <CircularProgress />
          </div>
        ) : error ? (
          ""
        ) : (
          slidersData.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className={`mt-10 ${
                  i18n.language === "ar" ? "text-end" : "text-start"
                }`}
              >
                <div
                  ref={(el) => (slidesRef.current[index] = el)}
                  className={` transition-transform duration-500 cursor-pointer ${
                    index === activeIndex
                      ? "bg-white text-[#596175] border-t-4 border-[#3d67d1] shadow-xl -mt-6 transform scale-105 z-10"
                      : "bg-[#1d2331] text-[#f7f9fd] mt-0 shadow-sm z-0 mx-1"
                  }`}
                  onClick={() => navigate(`${item?.url}`)}
                >
                  <img
                    src={imageLiveUrl(item?.image)}
                    alt=""
                    className="w-full h-44 object-cover"
                  />
                  <div className="px-5 py-4">
                    <p className="mb-4">
                      {i18n.language === "ar"
                        ? item?.description_ar
                        : item?.description}
                    </p>
                    <p className="mb-4">
                      {i18n.language === "ar"
                        ? item?.caption_ar
                        : item?.caption}
                    </p>
                    <p className="mb-4">
                      {i18n.language === "ar" ? item?.title_ar : item?.title}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))
        )}
      </Swiper>
      {/* Optional: Navigation Buttons */}
    </div>
  );
};

export default Slidersection;
